export const clientAccountLabels = {
    CLIENT_ACCOUNT: 'Client Account',
    SUB_CLIENT_NAME: 'Sub Client Name',
    SUPER_DISPATCH_CUSTOMER_ID: 'Super Dispatch Customer ID',
    NOT_SET: 'Not set',
};

export const clientAccountMessages = {
    SAVE_SUCCESS: 'Successfully saved your change',
    SAVE_ERROR: 'Error saving your change',
    INVALID_SUPER_DISPATCH_CUSTOMER_ID: 'Enter a valid GUID, e.g. 3fa85f64-5717-4562-b3fc-2c963f66afa6',
};

export const superDispatchCustomerIdPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
